import React, { createContext, useContext } from "react";
import { usePersistedSearch } from "hooks/usePersistedSearch";

const SearchContext = createContext(null);

export function SearchProvider({
  namespace = "bin",
  campaignOptions = [],
  gatewayOptions = [],
  children,
}) {
  const value = usePersistedSearch({
    namespace,
    campaignOptions,
    gatewayOptions,
  });
  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  );
}

export function useSearch() {
  const ctx = useContext(SearchContext);
  if (!ctx) throw new Error("useSearch must be used within a SearchProvider");
  return ctx;
}
